<template>
    <!-- PhotoSwipe 官方示例模板，修改前请查看 https://photoswipe.com/documentation/getting-started.html -->
    <!-- Root element of PhotoSwipe. Must have class pswp. -->
    <div
        :class="['pswp', containerCls]"
        tabindex="-1"
        role="dialog"
        aria-hidden="true"
    >
        <!-- Background of PhotoSwipe.
      It's a separate element as animating opacity is faster than rgba(). -->
        <div class="pswp__bg"></div>
        <!-- Slides wrapper with overflow:hidden. -->
        <div class="pswp__scroll-wrap">
            <!-- Container that holds slides.
      PhotoSwipe keeps only 3 of them in the DOM to save memory.
      Don't modify these 3 pswp__item elements, data is added later on. -->
            <div class="pswp__container preview-container">
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
                <div class="pswp__item"></div>
            </div>
            <!-- Default (PhotoSwipeUI_Default) interface on top of sliding area. Can be changed. -->
            <div class="pswp__ui pswp__ui--hidden">
                <div class="pswp__top-bar" style="display: none !important;">
                    <!--  Controls are self-explanatory. Order can be changed. -->
                    <div class="pswp__counter"></div>
                    <button class="pswp__button pswp__button--close" title="Close (Esc)"></button>
                    <button class="pswp__button pswp__button--share" title="Share"></button>
                    <button class="pswp__button pswp__button--fs" title="Toggle fullscreen"></button>
                    <button class="pswp__button pswp__button--zoom" title="Zoom in/out"></button>
                    <!-- Preloader demo http://codepen.io/dimsemenov/pen/yyBWoR -->
                    <!-- element will get class pswp__preloader--active when preloader is running -->
                    <div class="pswp__preloader">
                        <div class="pswp__preloader__icn">
                            <div class="pswp__preloader__cut">
                                <div class="pswp__preloader__donut"></div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="pswp__share-modal pswp__share-modal--hidden pswp__single-tap">
                    <div class="pswp__share-tooltip"></div>
                </div>
                <button class="pswp__button pswp__button--arrow--left" title="Previous (arrow left)"></button>
                <button class="pswp__button pswp__button--arrow--right" title="Next (arrow right)"></button>
                <div class="pswp__caption">
                    <div class="pswp__caption__center"></div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PhotoSwipe from 'photoswipe';
import UI from 'photoswipe/dist/photoswipe-ui-default';
import 'photoswipe/dist/photoswipe.css';
import 'photoswipe/dist/default-skin/default-skin.css';
import { getUrlParam } from '../../../utils/url';
const COMPONENT_NAME = 'ps-previewer';

export default {
    name: COMPONENT_NAME,
    beforeCreate() {
        this.CSS_PREFIX = COMPONENT_NAME;
    },
    props: {
        list: {
            type: Array,
            default: () => [],
        },
        options: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            defaultOptions: {
                history: false,
                loop: false,
                tapToClose: true,
                closeOnScroll: false,
                errorMsg: '<div class="pswp__error-msg">图片加载失败</div>',
                // ui options
                shareEl: false,
                closeEl: false,
                captionEl: false,
                fullscreenEl: false,
                zoomEl: false,
                counterEl: false,
                arrowEl: !!getUrlParam('isPc'),
                preloaderEl: false,
            },
        };
    },
    computed: {
        containerCls() {
            return {
                [`${this.CSS_PREFIX}`]: true,
            };
        },
        imgs() {
            return this.list.map(({ src, msrc = src, w = 0, h = 0 }) => ({ src, msrc, w, h }));
        },
    },
    methods: {
        init(index) {
            const galleryPswp = new PhotoSwipe(this.$el, UI, this.imgs, {
                ...this.defaultOptions,
                ...this.options,
                index,
            });
            this.photoswipe = galleryPswp;
            this.photoswipe.init();
            this.photoswipe.listen('close', () => {
                this.$emit('on-close');
                this.photoswipe = null;
            });
            this.photoswipe.listen('afterChange', () => {
                const { currItem } = galleryPswp || {};
                // 将图片缩放到适合屏幕宽度的比例，并确保图片顶部与屏幕顶部对齐
                const newScale = galleryPswp.viewportSize.x / currItem.w;
                galleryPswp.zoomTo(newScale, { x: galleryPswp.viewportSize.x / 2, y: 0 }, false);
                this.$emit('on-index-change', {
                    currentIndex: this.photoswipe.getCurrentIndex(),
                });
            });
            // 初始放大动画结束后触发 用户首次点击图片打开预览时，PhotoSwipe 会执行初始的放大动画
            galleryPswp.listen('initialZoomInEnd', function () {
                const { currItem } = galleryPswp || {};
                const newScale = galleryPswp.viewportSize.x / currItem.w;
                // x: galleryPswp.viewportSize.x / 2  将缩放中心放置在视口水平居中 false: 缩放效果有动画效果
                galleryPswp.zoomTo(newScale, { x: galleryPswp.viewportSize.x / 2, y: 0 }, false);
            });
            galleryPswp.framework.bind(
                galleryPswp.scrollWrap /* bind on any element of gallery */,
                'pswpTap',
                () => {},
            );
        },
        show(index) {
            this.init(index || 0);
        },
        getCurrentIndex() {
            return this.photoswipe.getCurrentIndex();
        },
        close() {
            this.photoswipe.close();
        },
        goTo(index) {
            this.photoswipe.goTo(index);
        },
        prev() {
            this.photoswipe.prev();
        },
        next() {
            this.photoswipe.next();
        },
    },
};
</script>
<style lang="less" scoped>
.preview-container {
    /deep/ .pswp__error-msg {
        width: 100% !important;
    }
}
</style>
